import React from 'react';
import { Phone } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingButtons = () => {
  const phoneNumber = "+917349519354";
  const whatsappNumber = "917349519354"; // Without + for WhatsApp
  const message = "Hello! I'm interested in your cab services.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group fixed bottom-5 left-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl ring-4 ring-white transition-all duration-300 hover:scale-110 hover:bg-[#20BA5C] focus:outline-none focus:ring-4 focus:ring-green-200 sm:bottom-6 sm:left-6"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={30} aria-hidden="true" />
        <span className="pointer-events-none absolute left-16 rounded-lg bg-gray-900 px-3 py-2 text-sm text-white opacity-0 shadow-lg transition-opacity duration-300 whitespace-nowrap group-hover:opacity-100">
          WhatsApp
        </span>
      </a>

      <a
        href={`tel:${phoneNumber}`}
        className="group fixed bottom-5 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-blue-600 text-white shadow-xl ring-4 ring-white transition-all duration-300 hover:scale-110 hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-200 sm:bottom-6 sm:right-6"
        aria-label="Call us"
      >
        <Phone size={25} aria-hidden="true" />
        <span className="pointer-events-none absolute right-16 rounded-lg bg-gray-900 px-3 py-2 text-sm text-white opacity-0 shadow-lg transition-opacity duration-300 whitespace-nowrap group-hover:opacity-100">
          Call
        </span>
      </a>
    </>
  );
};

export default FloatingButtons;
